<scope-deliverables-row-header
  *ngIf="!config?.isIndependent && !config?.isTimeline"
  [level]="level"
  [config]="config" />

<div
  [ngClass]="{ 'drag-target': scopeElementsService.deliverableDragging }"
  class="deliverables-container"
  scopeInfiniteScroll
  (scrolledDown)="onScrolledDown.emit()"
  id="list-one"
  cdkDropList
  [cdkDropListConnectedTo]="config?.sectionDrops"
  [cdkDropListData]="deliverables"
  [cdkDropListDisabled]="!config?.isEditable"
  (cdkDropListDropped)="onDropDeliverable.emit({ event: $event, section: null })">
  <ng-container *ngIf="!(config?.isDeliverablesLoading$ | async) && !deliverables?.length">
    <ng-content *ngIf="!config?.isDefaultSection"></ng-content>

    <div
      *ngIf="config?.isDefaultSection"
      class="text-for-empty deliverables-empty">
      <p class="text">Drag &amp; Drop {{ 'deliverable.p' | lang }}</p>
      <p class="undertext">between sections or from this default section</p>
    </div>
  </ng-container>

  <div
    cdkDrag
    *ngFor="let deliverable of deliverables; trackBy: trackById"
    [cdkDragData]="deliverable"
    [cdkDragDisabled]="scopeElementsService.disableDragging"
    (cdkDragStarted)="scopeElementsService.deliverableDragging = true"
    (cdkDragEnded)="scopeElementsService.deliverableDragging = false; scopeElementsService.dragTargetId = null"
    class="item-loader-container">
    <mat-icon class="material-symbols-rounded drag-indicator">drag_indicator</mat-icon>
    <div
      *ngIf="deliverableLoadingMap$(deliverable.section?.id, deliverable.id) | async"
      class="item-loader">
      <img
        src="/assets/icons/loading.svg"
        alt="loading"
        class="icon-spinner" />
    </div>

    <scope-deliverables-row
      class="tr scope-row flex-col"
      [class.scope-row__outlined]="config?.isIndependent"
      [config]="config"
      [deliverable]="deliverable"
      [deliverableMenuOptions]="deliverableMenuOptions"
      [componentMenuOptions]="componentMenuOptions"
      [feeMenuOptions]="feeMenuOptions"
      [level]="level"
      [cdnConfig]="cdnConfig"
      [changeItem]="(config?.changeItemsMap$ | async)?.[deliverable.changeAuditData?.identity || deliverable.id]"
      (onExpandDeliverable)="expandDeliverable(config?.scopeVersion.identity.id, deliverable.id)"
      (onUpdateDeliverable)="onUpdateDeliverable.emit($event)"
      (onUpdateComponent)="onUpdateComponent.emit($event)"
      (onUpdateFeeItem)="onUpdateFeeItem.emit($event)"
      (onUpdateRole)="onUpdateRole.emit($event)"
      (onUpdateDeliverableTpc)="onUpdateDeliverableTpc.emit($event)"
      (onUpdateComponentTpc)="onUpdateComponentTpc.emit($event)"
      (onUpdateDeliverableSectionTpc)="onUpdateDeliverableSectionTpc.emit($event)"
      (onReorderDeliverableTpcs)="onReorderDeliverableTpcs.emit($event)"
      (onReorderComponentTpcs)="onReorderComponentTpcs.emit($event)"
      (onReorderDeliverableSectionTpcs)="onReorderDeliverableSectionTpcs.emit($event)"
      (onAcceptDeliverable)="onAcceptDeliverable.emit($event)"
      (onRejectDeliverable)="onRejectDeliverable.emit($event)"
      (onMoveComponent)="onMoveComponent.emit($event)"
      (onMoveComponentOutsideDeliverable)="onMoveComponentOutsideDeliverable.emit($event)"
      (onOverrideComponentQuantity)="onOverrideComponentQuantity.emit($event)"
      (onOverrideRateCardRoleHours)="onOverrideRateCardRoleHours.emit($event)" />
  </div>
</div>

<div
  *ngIf="config?.isDeliverablesLoading$ | async"
  class="deliverables-loader">
  <img
    src="/assets/icons/loading-dark.svg"
    alt="loading"
    class="icon-spinner" />
</div>
